import { Injectable } from '@angular/core';
import { WebapiService } from './webapi.service';
import { SessionService } from './session.service';
import * as _ from "lodash";

@Injectable()
export class AuthService {

  user: string = null;
  token: string = null;
  USER_KEY: string = "user";
  TOKEN_KEY: string = "token";
  public HTTP_HEADER_KEY: string = "X-AUTH-TOKEN";

  constructor(private http: WebapiService, private session: SessionService) {
    this.user = this.session.readKey(this.USER_KEY);
    this.token = this.session.readKey(this.TOKEN_KEY);
    console.log("auth-service: " + this.user);
  }

  login(user: string, pass: string) {
    return this.http.sPost("authenticate/login", { username: user, password: pass });
  }
  logout() {
    this.session.clear();
    this.http.removeHeader(this.HTTP_HEADER_KEY);
    this.http.buildOptions();
  }
  setUser(user: any) {
    this.user = user.user;
    this.token = user.token;
    this.session.removeItem(this.USER_KEY);
    this.session.removeItem(this.TOKEN_KEY);
    this.session.saveKey(this.USER_KEY, this.user);
    this.session.saveKey(this.TOKEN_KEY, this.token);
    this.http.addHeader(this.HTTP_HEADER_KEY, "" + this.token);
    this.http.buildOptions();
  }
  isAuthenticateUser() {
    return !_.isNull(this.user) && !_.isNull(this.token);
  }
  getUser(){
    return this.user;
  }
}


// WEBPACK FOOTER //
// /Users/eduar.doramirez/developer/code/edd/ceramicamx/web/cmx-catalog/src/app/services/core/auth.service.ts